import ArchiveBackendsPage from "archive/ArchiveBackendsPage";
import ArchivePage from "archive/ArchivePage";
import ArchiveConfigurationPage from "archive/ArchiveConfigurationPage";
import ArchiveBackendConfigurationPage from "archive/ArchiveBackendConfigurationPage";
import ArchiveRetentionStrategySummary from "archive/components/ArchiveRetentionStrategySummary";
import ArchiveRetentionStrategyConfiguration from "archive/components/ArchiveRetentionStrategyConfiguration";
import ArchiveIndexSetPage from "archive/ArchiveIndexSetPage";
import ArchiveIndexSetConfigurationPage from "archive/ArchiveIndexSetConfigurationPage";
import indexArchiveBinding from "archive/IndexArchiveBinding";
import useExcludedStreams from "archive/hooks/useExcludedStreams";
import { indexSetArchiveRetentionTableElements } from "archive/index-set/indexSetArchiveRetentionColumn";
import ArchiveRoutes from "archive/Routes";
import { PAGE_NAV_TITLE as INDICES_PAGE_NAV_TITLE } from "components/indices/bindings";
import { CONFIGURATION_NAV_TITLE } from "common/Constants";
export const PAGE_NAV_TITLE = "Archives";
export default {
  routes: [
    { path: ArchiveRoutes.unqualified.LIST, component: ArchivePage },
    { path: ArchiveRoutes.unqualified.CONFIGURATION, component: ArchiveConfigurationPage },
    { path: ArchiveRoutes.unqualified.BACKENDS.LIST, component: ArchiveBackendsPage },
    { path: ArchiveRoutes.unqualified.BACKENDS.CREATE, component: ArchiveBackendConfigurationPage },
    { path: ArchiveRoutes.unqualified.BACKENDS.show(), component: ArchiveBackendConfigurationPage },
    { path: ArchiveRoutes.unqualified.INDEX_SET.SHOW, component: ArchiveIndexSetPage, permissions: ["indexsets:read"] },
    {
      path: ArchiveRoutes.unqualified.INDEX_SET.CONFIGURATION,
      component: ArchiveIndexSetConfigurationPage,
      permissions: ["indexsets:edit"]
    }
  ],
  indexRetentionConfig: [
    {
      type: "org.graylog.plugins.archive.indexer.retention.strategies.ArchiveRetentionStrategy",
      displayName: "Archive Index",
      configComponent: ArchiveRetentionStrategyConfiguration,
      summaryComponent: ArchiveRetentionStrategySummary
    }
  ],
  pageNavigation: [
    {
      description: PAGE_NAV_TITLE,
      children: [
        { description: "Overview", path: ArchiveRoutes.LIST, exactPathMatch: true },
        {
          description: CONFIGURATION_NAV_TITLE,
          path: ArchiveRoutes.CONFIGURATION,
          permissions: ["archiveconfig:read", "archiveconfig:update"]
        },
        {
          description: "Manage Backends",
          path: ArchiveRoutes.BACKENDS.LIST,
          permissions: ["archiveconfig:read", "archiveconfig:update"]
        }
      ]
    },
    {
      description: INDICES_PAGE_NAV_TITLE,
      children: [
        {
          description: "Restored Archives Index Set",
          path: ArchiveRoutes.INDEX_SET.SHOW,
          permissions: ["indexsets:read"],
          position: {
            after: "Indices & Index Sets"
          }
        }
      ]
    }
  ],
  "indices.archive": [indexArchiveBinding],
  "components.indexSets.overview.tableElements": indexSetArchiveRetentionTableElements(),
  archive: [{ hooks: { useExcludedStreams } }]
};
